define(function (require) {
    'use strict';

    var LE = require('app');
    var Media = require("media");
    var CONST = require("const");
    var LEConfig = require("assets/config/le-env-conf");

    var Loader = require("ui/loader/Loader");

    // CONTROLLERS
    var BaseRouterController = require("controllers/BaseRouterController");

    var TrialController = require("registration-controllers/TrialController");
    var BuyNowController = require("registration-controllers/BuyNowController");
    var ChangePlanController = require("registration-controllers/ChangePlanController");

    var BillingManager = require("registration-controllers/BillingManager");

    // VIEW
    var RegistrationMainLayout = require("registration-views/RegistrationMainLayout");
    var MyAccountView = require("registration-views/my-account/MyAccountView"); //my account
    var Page = require("ui.components/page/Page"); //my account
    var RegistrationSomethingWentWrongView = require("registration-views/RegistrationSomethingWentWrongView");


    // MODEL
    var BaseModel = require("models/BaseModel"); //my account
    var RegistrationVerificationModel = require("registration-models/RegistrationVerificationModel");


    // COLLECTION
    var BaseCollection = require("collections/BaseCollection"); //my account
    var PlansCollection = require('registration-collections/PlansCollection');

    // UTILS
    var RegistrationObjectUtil = require("registration-utils/RegistrationObjectUtil");
    var RegistrationStorageUtil = require("registration-utils/RegistrationStorageUtil");
    var GoogleAnalytics = require("registration-google/GoogleAnalytics");
    var LEResourceResolver = require("leResourceResolver");

    var RegistrationRouteController = {};
    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {

        RegistrationRouteController = BaseRouterController.extend({

            /**
             * INITIALIZATIONS and LIFECYCLE
             */

            navigation: {
                routes: {
                    "": "routeToDefault",

                    "signUp":{
                        callback:  "routeToRegistrationSignUp",
                        name: "RegistrationSignUp",
                        auth: {
                            privileges: []
                        }
                    },
                    "createAccount":{
                        callback:  "routeToRegistrationCreateAccount",
                        name: "RegistrationCreateAccount",
                        auth: {
                            privileges: []
                        }
                    },
                    "buyNow":{
                        callback:  "routeToBuyNowInfo",
                        name: "BuyNowInfo",
                        auth: {
                            privileges: []
                        }
                    },
                    "changePlanSelection":{
                        callback:  "routeToPlanSelection",
                        name: "PlanSelection",
                        auth: {
                            privileges: [6]
                        }
                    },
                    "myAccount":{
                        callback:  "routeToMyAccount",
                        name: "MyAccount",
                        auth: {
                            privileges: [6]
                        }
                    },
                    "error/:errorCode/:returnPage":{
                        callback:  "routeToRegistrationSomethingWentWrong",
                        name: "RegistrationSomethingWentWrong",
                        auth: {
                            privileges: []
                        }
                    }
                },
                defaultRoute: ""
            },

            initialize: function (options) {
                this.vent = Media.vent();
                this._createControllers(options);
                this.layout = new RegistrationMainLayout();

                // members to be referenced buy sub-controllers
                this.isShowDetails = false;
                this.historyRouter = null;

                this.registrationVerificationModel = new RegistrationVerificationModel();

                /*LEConfig.Billing.billingInLe= false;
                LEConfig.Billing.upgradeInLe= false;
                LEConfig.Billing.allowAmendment= true;*/

                LERegistration.channel.comply(LE.mediaCodes.registration.commands.accountSettings, _.bind(function() {
                    this.saveHistoryRoute();
                    this.routeToDefault(true);
                }, this));

            },

            saveHistoryRoute: function() {
                if(CONST.MODULES.REGISTRATION !== LE.context.get("activeModuleName")) {
                    if(LE.context.get("navigationCurrent.fixedRoute") && LE.context.get("navigationCurrent.fixedRoute").indexOf("registration!error") == -1){
                        this.historyRouter = LE.context.get("navigationCurrent.fixedRoute");
                    }
                }
            },

            showLoader: function(){
                if (!this.loader){
                    this.loader = new Loader({
                        permutation: Loader.PERMUTATION.A,
                        el: '.le .reg'
                    });
                }
                this.loader.render();
            },

            closeLoader: function() {
                if(this.loader){
                    this.loader.close();
                }
            },

            // TODO: utilizing error message awaits for connection-panel to support adding a message to the agent
            openChat: function(messageToAgent) {
                // messageToAgent should be JSON string, for example:  {"errorCode": "5", "text": "abc"}
                LE.crossModule("connection" , LE.media.actions.command ,LE.mediaCodes.connection.commands.startChatWithGroup, {group:"Registration"});
            },

            /**
             * MEMBER PROTECTED
             * contextual to this
             */


            //------------------------------------------------------

            _openChatCallback: function(isSuccess){
                LERegistration.logger.info("Callback isSuccess value: " + isSuccess, "RegistrationRouteController:_openChatCallback");
            },

            _createControllers: function(options){
                this.flowModel = new BaseModel();

                this.trialController = new TrialController({
                    vent: this.vent,
                    controller: this
                });

                this.buyNowController = new BuyNowController({
                    vent: this.vent,
                    controller: this
                });

                this.changePlanController = new ChangePlanController({
                    vent: this.vent,
                    controller: this
                });

                this.billingManager = new BillingManager({
                    vent: this.vent,
                    controller: this
                });

            },

            /**
             * EXTERNAL API
             */

            getMainView: function(){
                return this.layout;
            },

            refreshView: function(){
                var view= this.layout.mainRegion.currentView;
                if(view){
                    this.showViewInMainRegion(view, true);
                }
            },

            showViewInMainRegion: function(view, skipAnalytics, hash) {
                this.layout.mainRegion.show(view);
                this.layout.mainRegion.$el.scrollTop(0);
                if(!skipAnalytics){
                    GoogleAnalytics._runGoogleAnalyticsTag(hash);
                }
            },

            /**
             * ROUTINGS
             */


            routeToRegistrationSomethingWentWrong: function (errorCode,returnPage) {
                LERegistration.logger.info("Showing the something went wrong page", "RegistrationRouteController:routeToRegistrationSomethingWentWrong");

                returnPage= decodeURIComponent(returnPage);

                var options = {
                    model: this.registrationVerificationModel,
                    errorCode: errorCode,
                    returnPage: returnPage
                };
                var registrationSomethingWentWrongView = new RegistrationSomethingWentWrongView(options);
                this.showViewInMainRegion(registrationSomethingWentWrongView);
            },


            // TRIAL(SIGNUP) ROUTE HANDLING
            routeToRegistrationSignUp: function () {
                var authenticated = LE.sessionManager.isAuthenticated();
                if(!authenticated) {
                    var paramsObject= RegistrationObjectUtil.urlParamsToJSON(RegistrationObjectUtil.ENUM_MODE.SIGNUP);
                    RegistrationStorageUtil.saveAffiliateQueryParams(paramsObject);
                    var info = RegistrationObjectUtil.buildRegistrationVerficationObject(paramsObject);
                    this.registrationVerificationModel.set(info);

                    this.trialController.showSignUpView();
                } else {
                    // TODO: verify navigation to app default
                    //LE.router.navigate(LE.context.get("modulesNavigation.LEWebAgent.fixedRoute"));
                    this.routeToDefault();
                }
            },

            routeToRegistrationCreateAccount: function () {
                var paramsObject= RegistrationObjectUtil.urlParamsToJSON(RegistrationObjectUtil.ENUM_MODE.CREATE_ACCOUNT);
                this.trialController.showCreateAccountView(paramsObject);
            },


            // BUYNOW ROUTE HANDLING
            routeToBuyNowInfo: function () {
                var paramsObject= RegistrationObjectUtil.urlParamsToJSON(RegistrationObjectUtil.ENUM_MODE.BUY_NOW);
                this.buyNowController.showBuyNowInfo(paramsObject);
            },

            noRoutePlanSelection: function(){
                var isTrialDeferred= this.billingManager.isTrial();
                $.when(isTrialDeferred).done(_.bind(function(isTrial){
                    var showPlanSelection= isTrial;
                    if(showPlanSelection){
                        var onboardInLe= isTrial && LEConfig.Billing.billingInLe;
                        var upgradeInLe= !isTrial && LEConfig.Billing.upgradeInLe;
                        if(onboardInLe || upgradeInLe){
                            LERegistration.router.navigate("changePlanSelection");
                        }else{
                            this.gotoLPComBilling(isTrial);
                        }
                    }else{
                        this.openChat();
                    }
                },this))
                .fail(_.bind(function(message, errorCode, response) {
                    message+= "isTrial api call has failed upon executing plan selection(no routing version).";
                    this.handleRegistrationError(message, errorCode, null, null, response);
                },this));
            },

            // CHANGE_PLAN ROUTE HANDLING
            routeToPlanSelection: function () {
                this.showLoader();
                var isTrialDeferred= this.billingManager.isTrial();
                $.when(isTrialDeferred).done(_.bind(function(isTrial){
                    this.closeLoader();
                    var showPlanSelection= isTrial;
                    if(showPlanSelection){
                        var onboardInLe= isTrial && LEConfig.Billing.billingInLe;
                        var upgradeInLe= !isTrial && LEConfig.Billing.upgradeInLe;
                        if(onboardInLe || upgradeInLe){
                            var paramsObject= RegistrationObjectUtil.urlParamsToJSON(RegistrationObjectUtil.ENUM_MODE.CHANGE_PLAN);
                            this.changePlanController.showPlanSelectionView(paramsObject);
                            LE.crossModule("reporting", LE.media.actions.command, LE.mediaCodes.reporting.commands.hideReportingComponents);
                        }else{
                            this.gotoLPComBilling(isTrial);
                        }
                    }else{
                        this.openChat();
                    }
                },this))
                .fail(_.bind(function(message, errorCode, response) {
                    message+= "isTrial api call has failed upon route to plan selection.";
                    this.handleRegistrationError(message, errorCode, null, null, response);
                },this));
            },

            routeToMyAccount: function (){
                // incase myaccount is blocked
                var hasLEMyAccount= LE.sessionManager.hasLEMyAccount();
                if(!hasLEMyAccount){
                    this.routeToDefault();
                    return;
                }
                this.showLoader();
                var isTrialDeferred= this.billingManager.isTrial();
                $.when(isTrialDeferred)
                 .done(_.bind(function(isTrial){
                    if(isTrial){
                        this.closeLoader();
                        this.routeToDefault();
                        return;
                    }

                    if(_.isUndefined(this.myAccountViewPage)){
                        // creates my account view
                        var myAccountView = new MyAccountView({
                            model:  this.flowModel,
                            controller: this
                        });

                        // creates a wrapping page view
                        this.myAccountViewPage = new Page({
                            moduleName:LERegistration.moduleName,
                            context:LE.context,
                            view: myAccountView,
                            header: {
                                title: LE.translator.translate("LERegistration.myAccount.title"),
                                description: LE.translator.translate("LERegistration.myAccount.description")
                            },
                            permutation: Page.PERMUTATION.Dialog
                        });

                        // registers a page cancel handler
                        this.listenTo(myAccountView, MyAccountView.TRIGGERING.CANCEL_BUTTON_CLICKED, _.bind(function(){
                            this.routeToPrevious();
                        },this));
                    }

                    // display view
                    this.showViewInMainRegion(this.myAccountViewPage);
                    this.closeLoader();
                    LE.crossModule("reporting", LE.media.actions.command, LE.mediaCodes.reporting.commands.hideReportingComponents);
                 }, this))
                 .fail(_.bind(function(message, errorCode, response) {
                    message+= "isTrial api call has failed upon route to my account.";
                    this.handleRegistrationError(message, errorCode, null, null, response);
                 },this));
            },

            // GENERAL ROUTE HANDLING
            routeToDefault: function (verboseIsTrial) {
                if(LE.sessionManager && LE.sessionManager.isAuthenticated()) {
                    this.saveHistoryRoute();
                    this.changePlanController.isRetainHistoryRouter = true;
                    var isTrialDeferred= this.billingManager.isTrial(verboseIsTrial);
                    $.when(isTrialDeferred)
                        .done(_.bind(function(isTrial){
                            if(isTrial){
                                this.noRoutePlanSelection();
                            }else{
                                //show my account incase paying
                                var hasLEMyAccount= LE.sessionManager.hasLEMyAccount();
                                if(hasLEMyAccount){
                                    var upgradeInLe= LEConfig.Billing.upgradeInLe;
                                    if(upgradeInLe){
                                        LERegistration.router.navigate("myAccount");
                                    }else{
                                        this.gotoLPComBilling(isTrial);
                                    }
                                }else{
                                    this.routeToPrevious();
                                }
                            }
                        }, this))
                        .fail(_.bind(function(message, errorCode, response) {
                            message+= "isTrial api call has failed upon routing to default Registration route.";
                            this.handleRegistrationError(message, errorCode, "wa!webagent", null, response);
                        },this));
                }else{
                    LERegistration.router.navigate( "signUp");
                }
            },

            gotoLPComBilling: function(isTrial){
                isTrial= isTrial || false;
                var upgradeBillingUrl = LE.getUpgradeBillingUrl();
                if(!isTrial){
                    //go to an lpcom myaccount endpoint
                    upgradeBillingUrl = LE.getLPComMyAccountBillingUrl();
                }
                LERegistration.router.open(upgradeBillingUrl, "_blank");
                LERegistration.notifier.showInfo({"content": LE.translator.translate("LERegistration.planSelection.opened.in.new.window"),"timeToShow": 15000});
            },

            gotoLPComUpdateDetails: function(){
                var updateDetailsUrl = LE.getUpdateDetailsBillingUrl();
                LERegistration.router.open(updateDetailsUrl, "_blank");
            },

            routeToPrevious: function (){
                var route= this.historyRouter || LE.context.get("modulesNavigation.LEWebAgent.fixedRoute") || "wa!webagent";
                LE.router.navigate(route);
            },

            handleRegistrationError: function(message, errorCode, returnPage, errorObject, response){
                this.closeLoader();

                var serverMessage= (response && response.responseError && response.responseError.message) || (response && response.statusText);
                message+= (serverMessage ? "Server said: " + serverMessage : "");

                var serverCode= (response && response.responseError && (response.responseError.code || response.responseError.errorCode)) || (response && response.status);
                errorCode+= (serverCode ? (":"+serverCode) : "");

                // a side scenario where a user successfuly pays however fails
                // the success redirect to My Account(eg: trial to paying will fail usage api),
                // hence we send him to previous route outside the registration module.
                if(this.billingManager.routeToHomeForMyAccountFailWhenJustPurchased){
                    this.billingManager.routeToHomeForMyAccountFailWhenJustPurchased= false;
                    this.routeToPrevious();
                    return;
                }

                if(returnPage){
                    //use local module route prefix incase module not specified.
                    if( returnPage.indexOf("!") === -1 ){
                        returnPage= "registration!" + returnPage;
                    }
                }else{
                    this.saveHistoryRoute();
                }

                var returnPath= encodeURIComponent(returnPage || this.historyRouter || "");
                LERegistration.router.navigate("error/" + errorCode +"/" + returnPath);

                this.openChat({ message: message });
                //LERegistration.notifier.showError(LE.translator.translate("LERegistration.plan.error.chatWithUs"));
                LERegistration.logger.error(message, "RegistrationRouteController:handleRegistrationError", errorObject);
            }

        });

        /**
         * PRIVATE FUNCTIONS
         * only available inside the closure
         */



    });
    return  RegistrationRouteController;
});
